<template>
  <DxPopup @hidden="onHidden" :visible="showContactUsPop" :show-close-button="true" :show-title="true" :title="menuTitle" height="auto" width="640" container=".v-application">
    <div class="h-full">
      <div class="pa-2" style="border: 1px solid #cccccc;">
        <table width="420" border="0" cellpadding="0" cellspacing="0" align="center">
          <tr>
            <td>
              <OL type="A" style="font-size:12pt; font-weight:bolder; font-family:Arial;">
                <LI>Contact Us : 0583.622101</LI>
                  <OL type="I" style="font-size:11pt;">
                    <LI>IT Dep't (Vietnamese)</LI>
                      <OL type="a" style="font-size:9pt;">
                        <LI>Lê Minh Tri : 2497 </LI>
                        <LI>Nguyễn Lê Hoàng Yến: 2487</LI>
                        <LI>Võ Huy Chiến: 2496</LI>
                        <LI>Hàng Tấn Đạt: 2496</LI>
                        <LI>Nguyễn Thanh Nhựt: 2496<br><br></LI>
                      </OL>
                  </OL>
                <LI>Number Format</LI>
                  <OL type="I" style="font-size:11pt">
                    <LI>English</LI>
                      <OL type="a" style="font-size:9pt">
                        <LI>
                          Decimal symbol : .<br>
                          Example<br>
                          50.12 / 12.34
                        </LI>
                        <LI>
                          Digit grouping symbol : ,<br>
                          Example<br>
                          1,234 / 1,234.56 / 12,345,678.9
                        </LI>
                      </OL>
                    <LI>Tiếng Việt</LI>
                      <OL type="a" style="font-size:9pt">
                        <LI>
                          Dấu thập phân : .<br>
                          Ví dụ<br>
                          50.12 / 12.34
                        </LI>
                        <LI>
                          Phân biệt số hàng ngàn : ,<br>
                          Ví dụ<br>
                          1,234 / 1,234.56 / 12,345,678.9
                        </LI>
                      </OL>
                  </OL>
                <LI>WEB Browser : Internet Explorer 5.0 or higher</LI>
              </OL>
            </td>
          </tr>
        </table>
      </div>

      <div class="pt-2 d-flex justify-center align-center">
        <v-checkbox v-model="openChk" label="Don't show this window during today." on-icon="mdi-check-circle-outline" off-icon="mdi-checkbox-blank-circle-outline" />
        <i-button :text="'Close'" :isCustom="true" @click="btnClose" class="ml-2" />
      </div>
    </div>
  </DxPopup>
</template>

<script>
import baseview from '@/components/base/baseview'
import { DxPopup } from 'devextreme-vue/popup'
import iButton from '@/components/common/iButton'
import Cookies from 'js-cookie'

export default {
  name: 'contactUsPop',
  mixins: [baseview],
  components: {
    DxPopup,
    iButton
  },
  props: {
    showContactUsPop: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
     return {
       menuTitle: 'Contact Information',
       openChk: false
     }
  },
  watch: {
    'showContactUsPop': {
      handler(value, oldValue) {
        if(value) {
          this.init()
        }
      },
      immediate: true
    }
  },
  methods: {
    init() {
      this.getOpenChk()
    },
    getOpenChk() {
      const isSaved = Cookies.get('epms_contact_us')

      if(isSaved) {
        this.openChk = true
      } else {
        this.openChk = false
      }
    },
    onHidden(e) {
      this.btnClose()
    },
    btnClose() {
      if(this.openChk) {
        let expDt = new Date()
        expDt.setTime(expDt.getTime() + 1000 * 3600 * 24 * 1)
        Cookies.set('epms_contact_us', 'Y', { expires: expDt, path: '' })
      } else {
        Cookies.remove('epms_contact_us')
      }

      this.$emit('update:showContactUsPop', false)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>